<template>
  <div>
    <slot>
      <MButton
        id="link-asset-btn"
        type="button"
        variant="neutral"
        class="mr-2"
        :disabled="isDisabled"
        @click.prevent.stop="addNewRelation"
      >
        <MIcon name="link" />
        {{ $t('link') }}
        {{ $tc(moduleName === $constants.CMDB ? 'ci' : 'asset', 2) }}
      </MButton>
    </slot>
    <MRow v-if="defaultSelectedAssets.length > 0" class="mt-4" :gutter="0">
      <MCol>
        <div
          v-for="asset in defaultSelectedAssets"
          :key="`${asset.id}${asset.model}`"
          class="selected-asset mb-2"
        >
          <MTooltip>
            <template v-slot:trigger>
              <div class="flex">
                <span class="md-text-base text-ellipsis flex-1">
                  {{ getAssetCiName(asset) }}
                </span>
                <FlotoAnchorLink
                  :ar-label="$t('delete')"
                  class="mx-2"
                  @click="removeAsset(asset)"
                >
                  <MTooltip placement="right">
                    <template v-slot:trigger>
                      <MIcon name="trash-alt" class="text-secondary-red" />
                    </template>
                    {{ $t('delete') }}
                  </MTooltip>
                </FlotoAnchorLink>
              </div>
            </template>
            {{ getAssetCiName(asset) }}
          </MTooltip>
        </div>
      </MCol>
    </MRow>
    <FlotoDrawer :open="showDrawer" width="65%" @hide="hideDrawer">
      <template v-slot:title>
        {{ $t('link') }}
        {{ $tc(moduleName === $constants.CMDB ? 'ci' : 'asset', 2) }}
      </template>
      <component
        :is="selectionComponent"
        selectable
        :source-module-name="$constants.CHANGE"
        :module-name="moduleName"
        :searchable="!isPortalLogin"
        :client-side-pagination="isPortalLogin"
        :fetch-fn="isPortalLogin ? fetchEligableRelations : undefined"
        :default-selected-item-ids="defaultSelectedAssets.map((a) => a.id)"
        :linkable="!isPortalLogin"
        :exclude-items-by-id="excludeItemsById"
        :hidden-columns="isPortalLogin ? ['assignedUserIds'] : []"
        @selection-change="setSelectedItems"
        @asset-sub-module-change="handleAssetSubModuleChange"
      />
      <template v-slot:actions="{ hide }">
        <MButton
          :disabled="selectedItems.length === 0"
          outline
          class="mx-1"
          :loading="processing"
          @click="handleAddRelations"
        >
          {{ $t('link') }}
        </MButton>
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </div>
</template>

<script>
import GroupBy from 'lodash/groupBy'
import { authComputed } from '@state/modules/auth'
import { getAssetCiByLogonEmailApi } from '@modules/asset/asset-api'
import AssetSelectionContainer from '@components/relation/asset-selection-container'
import AssetSelectionList from '@components/item-selection-list/asset-list'
export default {
  name: 'LinkAssetDrower',
  components: { AssetSelectionContainer },
  model: {
    event: 'change',
  },
  props: {
    defaultSelectedAssets: {
      type: Array,
      default() {
        return []
      },
    },
    serviceCatalogId: {
      type: Number,
      default: undefined,
    },
    moduleName: {
      type: String,
      default() {
        return this.$constants.ASSET
      },
    },
    emailOrLogon: { type: String, default: undefined },
    isDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      showDrawer: false,
      processing: false,
      selectedItems: [],
      selectedAssetSubModuleName: null,
      excludeItemsById: [],
    }
  },
  computed: {
    ...authComputed,
    selectionComponent() {
      if (this.isPortalLogin || this.moduleName === this.$constants.CMDB) {
        return AssetSelectionList
      }
      return AssetSelectionContainer
    },
    excludedItemGropByModuleName() {
      if (this.isPortalLogin) {
        return {}
      }
      return GroupBy(this.defaultSelectedAssets, 'model')
    },
  },
  methods: {
    fetchEligableRelations(targetModuleName, criterias, limit, offset) {
      if (this.isPortalLogin && this.emailOrLogon) {
        const additionalParams = {
          ...(this.moduleName === this.$constants.CMDB
            ? {
                linkCiCall: true,
              }
            : {
                linkAssetCall: true,
              }),
          ...(this.serviceCatalogId
            ? { serviceCatalogId: this.serviceCatalogId }
            : {}),
        }
        return getAssetCiByLogonEmailApi(
          this.moduleName,
          this.emailOrLogon,
          additionalParams
        ).then(({ items }) => {
          let allItems = items
          if (this.defaultSelectedAssets.length) {
            const selectedItemsIds = this.defaultSelectedAssets.map((d) => d.id)
            allItems = allItems.filter(
              (a) => selectedItemsIds.indexOf(a.id) === -1
            )
          }
          return allItems
        })
      }
    },
    handleAddRelations() {
      if (this.processing) {
        return
      }
      this.processing = true
      this.$emit('change', this.selectedItems)
      this.processing = false
      this.hideDrawer()
    },
    removeAsset(asset) {
      this.$emit(
        'change',
        this.defaultSelectedAssets.filter((a) => a.guid !== asset.guid)
      )
    },
    handleAssetSubModuleChange(subModuleName) {
      this.selectedAssetSubModuleName = subModuleName
      this.excludeItemsById = (
        this.excludedItemGropByModuleName[subModuleName] || []
      ).map((i) => i.id)
    },
    hideDrawer() {
      this.selectedItems = []
      this.showDrawer = false
    },
    setSelectedItems(items) {
      this.selectedItems = [...this.defaultSelectedAssets, ...items]
      // if (this.isPortalLogin) {
      //   this.selectedItems = items
      // } else {
      //   this.selectedItems = [...this.defaultSelectedAssets, ...items]
      // }
    },
    addNewRelation() {
      if (this.isDisabled) {
        return
      }
      setTimeout(() => {
        this.showDrawer = true
        // this.selectedItems = this.defaultselected-item.map((i) => ({ id: i }))
      }, 250)
    },
    getAssetCiName(asset) {
      if (this.moduleName === this.$constants.CMDB) {
        return `${asset.ciName} ${asset.ciDisplayName}`
      }
      return `${asset.name} ${asset.displayName}`
    },
  },
}
</script>

<style lang="less" scoped>
.selected-asset {
  @apply rounded-lg border inline-flex border-solid border-neutral-lighter px-2 py-1 mr-2 items-center;

  & .md-text-base {
    max-width: 300px;
  }
}
</style>
